import {
  type AdForPrompt,
  adMediumOf,
} from "src/pages/ad-studio/insights/ad-action-prompt";
import { useAdSurfaceStyles } from "src/pages/ad-studio/hooks/use-ad-surface-styles";
import {
  buildSuggestedActions,
  type SuggestedAction,
} from "src/pages/ad-studio/insights/ad-suggested-actions";
import type {
  FoundAd,
  SuggestedActionPick,
} from "src/pages/ad-studio/insights/performance/types";

export type SuggestedActionsState =
  | { status: "loading" }
  | { status: "loaded"; actions: readonly SuggestedAction[] };

export type SuggestedActionsAction = {
  kind: "SuggestedActionsAction/selected";
  action: SuggestedAction;
};

export function useSuggestedActions({
  ad,
  fatigue,
  performParentAction,
}: {
  ad: AdForPrompt;
  fatigue: FoundAd["fatigue"];
  performParentAction: (pick: SuggestedActionPick) => void;
}): {
  state: SuggestedActionsState;
  performAction: (action: SuggestedActionsAction) => void;
} {
  const { styles, isLoading } = useAdSurfaceStyles();
  const format = adMediumOf(ad.creative);
  const performAction = (action: SuggestedActionsAction) => {
    switch (action.kind) {
      case "SuggestedActionsAction/selected": {
        return performParentAction({ action: action.action, ad });
      }
      default: {
        return action.kind satisfies never;
      }
    }
  };
  return {
    state:
      isLoading && format !== "video"
        ? { status: "loading" }
        : {
            status: "loaded",
            actions: buildSuggestedActions({
              adId: ad.entityId,
              format,
              fatigue,
              savedStyles: styles,
            }),
          },
    performAction,
  };
}
